// extracted by mini-css-extract-plugin
module.exports = {"root":"az_o9c","ratingRadioButton":"az_p9c","ratingItemIcon":"az_q9c","empty":"az_r9c","a11label":"az_s9c"};